import * as React from 'react'

const Calendar3 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='Calendar Logo'
    fill='none'
    height='18'
    role='img'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Calendar Logo</title>
    <path d='M8 2v4' />
    <path d='M16 2v4' />
    <rect width='18' height='18' x='3' y='4' rx='2' />
    <path d='M3 10h18' />
  </svg>
)

export default Calendar3



// WEBPACK FOOTER //
// ./src/components/icons/ui/Calendar3.tsx